import React from "react";
import "./MainHero.css";
import "../../animations/index.css";
import { CircularProgressbarWithChildren } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { Logo } from "../../../assets";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";

const ProgressProvider = ({ valueStart, valueEnd, children }: any) => {
  const [value, setValue] = React.useState(valueStart);
  React.useEffect(() => {
    setTimeout(() => {
      setValue(valueEnd);
    }, 400);
  }, [valueEnd]);

  return children(value);
};

const ProgressBarRed = () => (
  <div id="hero_progress_bar" className="w-[300px] aspect-squared">
    <ProgressProvider valueStart={0} valueEnd={100}>
      {(value: any) => (
        <CircularProgressbarWithChildren
          value={value}
          styles={{
            path: {
              // Path color
              stroke: "#CC9287",
              // Customize transition animation
              transition: "stroke-dashoffset 0.5s ease 0s",
            },
          }}
        >
          <h1 className="text-RougePastel font-RobotoCondensed text-[50px] font-bold">
            3.9kg
          </h1>
          <h2 id="hero_progress_bar_title" className="text-RougePastel font-RobotoCondensed text-[35px]">
            CO2e/m² per year from gaz heating in France
          </h2>
        </CircularProgressbarWithChildren>
      )}
    </ProgressProvider>
  </div>
);

const ProgressBarBlue = () => (
    <div id="hero_progress_bar" className="w-[170px] aspect-squared">
      <ProgressProvider valueStart={0} valueEnd={60}>
        {(value: any) => (
            <CircularProgressbarWithChildren
                value={value}
                styles={{
                  path: {
                    // Path color
                    stroke: "#047481",
                    // Customize transition animation
                    transition: "stroke-dashoffset 0.5s ease 0s",
                  },
                }}
            >
              <h1 className="text-teal-600 font-RobotoCondensed text-[50px] font-bold">
                {value}%
              </h1>
            </CircularProgressbarWithChildren>
        )}
      </ProgressProvider>
      <h2 id="hero_progress_bar_title_2" className="text-teal-600 font-RobotoCondensed text-[15px]">
        Heating in energy consumption
      </h2>
    </div>
);

const ProgressBarGreeen = () => (
    <div id="hero_progress_bar" className="w-[250px] aspect-squared">
      <ProgressProvider valueStart={0} valueEnd={40}>
      {(value: any) => (
        <CircularProgressbarWithChildren
          value={value}
          styles={{
            path: {
              // Path color
              stroke: "#91BC6D",
              // Customize transition animation
              transition: "stroke-dashoffset 0.5s ease 0s",
            },
          }}
        >
          <h1 className="text-VertPastel font-RobotoCondensed text-[65px] font-bold">
            {value}%
          </h1>
          <h2 id="hero_progress_bar_title" className="text-VertPastel font-RobotoCondensed text-[15px] justify-center">
            French using gas for heating
          </h2>
        </CircularProgressbarWithChildren>
      )}
    </ProgressProvider>
  </div>
);

function MainHero() {
  return (
    <section className="flex flex-col justify-center items-center w-full h-full font-semibold md:flex-auto">
      <div className="flex flex-col justify-center md:justify-start items-center md:items-end md:max-w-[1350px] md:mx-auto w-full pt-[50px] md:pt-[100px] animate-fade-in ">
        <div className="flex w-full md:flex-row">
          <div className="hidden flex-auto gap-8 justify-end md:flex md:w-auto">
            <div className="flex flex-col gap-10 items-center">
              <ProgressBarRed />
              <ProgressBarBlue />
            </div>
            <div className="flex justify-center items-center">
              <ProgressBarGreeen />
            </div>
          </div>
          <div id="hero_main" className="flex flex-col md:w-auto h-full justify-center items-center md:items-end md:max-w-[1350px] md:mx-auto w-full animate-fade-in">
            <div className="flex flex-col justify-center items-center h-full md:flex-row-reverse md:gap-5">
              <div className="w-[200px] aspect-square md:w-[300px]">
                <Logo />
              </div>
              <div className="flex flex-col gap-0 w-full">
                <h1 id="hero_title_1" className="text-[40px] md:text-[100px] md:text-right leading-0">
                  Clean Heat
                </h1>
                <h2 className="hidden text-right text-[50px] font-normal text-VertPastel md:block">
                  green it!
                </h2>
              </div>
            </div>
            <span className="text-md font-Lexend w-[250px] text-center md:text-right md:w-[500px] md:text-2xl md:mt-5 font-thin">
              A bio-based{" "}
              <span className="font-bold text-RougePastel">heating</span> and{" "}
              <span className="font-bold text-BleuClair">water</span>{" "}
              depolutting system
            </span>
            <button className="mt-[60px] transition-colors ease-in-out delay-100 px-[20px] uppercase rounded-[15px] bg-BleuCanard font-Lexend font-semibold text-md py-[7px]  text-white hover:bg-white border-BleuCanard border-8 hover:text-BleuCanard">
              <a href="https://2023.igem.wiki/ionis-paris/description">Lean More</a>
            </button>
            <button className="mt-[20px] transition-colors ease-in-out delay-120 px-[20px] uppercase rounded-[15px] bg-VertPastel font-Lexend font-semibold text-md py-[7px]  text-white hover:bg-white border-VertPastel border-8 hover:text-VertPastel">
              <a href="https://2023.igem.wiki/ionis-paris/project/awards">Awards</a>
            </button>
          </div>
        </div>

        <div className="flex justify-center items-center w-full text-black opacity-50 _animate-bounce pt-[70px] md:h-full md:pt-[40px]">
          Slide down
          <FontAwesomeIcon icon={faAngleDown} />
        </div>
      </div>
    </section>
  );
}

export default MainHero;
